<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="650px" persistent>
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("viewGarage.adding_car") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="showWindow = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form autocomplete="nope" ref="form">
            <v-text-field
                outlined
                required
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                v-model="car.name"
                :label="$t('common.name')"
            ></v-text-field>
            <v-text-field
                outlined
                required
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                v-model="car.car_number"
                :label="$t('common.car_number')"
            ></v-text-field>
            <v-text-field
                outlined
                required
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                v-model="car.vin"
                :label="$t('common.vin_frame')"
            ></v-text-field>
            <v-text-field
                outlined
                required
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                v-model="car.brand"
                :label="$t('common.brand')"
            ></v-text-field>
            <v-text-field
                outlined
                required
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                v-model="car.family"
                :label="$t('common.family')"
            ></v-text-field>
            <v-text-field
                outlined
                required
                :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
                v-model="car.model"
                :label="$t('common.model')"
            ></v-text-field>
          </v-form>
          <v-divider class="mt-4"></v-divider>
          <v-card-actions class="pa-0 mx-0">
            <v-spacer></v-spacer>
            <v-btn class="white--text mt-5" elevation="0" color="red" @click="close" >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
                class="mt-5"
                color="primary"
                @click="submit"
                @keyup.enter="submit"
                elevation="0"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import BeautyCarNumber from "../common/BeautyCarNumber";
import CommonMixin from "@/mixins/common";

export default {
  name: "CarSelectorManualWindow",
  components: { BeautyCarNumber, MaintenanceParts },
  mixins: [CommonMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    car:{
      "name": null,
      "engine": null,
      "brand": null, //
      "catalog_code": {

      },
      "family": null,
      "model": null,
      "link": -1,
      "mileage": null,
      "vin": null,
      "car_number": null,
      "image": null
    }
  }),
  computed:{
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$refs["form"] && this.$refs["form"].resetValidation();
        this.$emit("hide");
      },
    },
  },
  methods: {
    close(){
      this.showWindow=false;
    },
    submit(){
      this.close();
      if (this.$refs["form"].validate()) {
        this.$emit("choose", this.car);
      }
    }
  },
};
</script>

